import { SAVE_LOCALE } from '../constant'
export const saveLocale = (data) => {
  return { type: SAVE_LOCALE, data }
}